import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var ReversePipe = (function () {
    function ReversePipe() {
    }
    ReversePipe.prototype.transform = function (input) {
        if (isString(input)) {
            return input.split('').reverse().join('');
        }
        return Array.isArray(input)
            ? input.reverse()
            : input;
    };
    return ReversePipe;
}());
export { ReversePipe };
ReversePipe.decorators = [
    { type: Pipe, args: [{ name: 'reverse' },] },
];
/** @nocollapse */
ReversePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=reverse.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/reverse.js
// module id = 208
// module chunks = 4